import React from "react";
import { TextFieldProps } from "@mui/material/TextField";
import { CustomTextField } from "../../views/AddSignatories/AddSignatories";
import { IMaskInput } from "react-imask";

type MaskedInputProps = TextFieldProps & {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
};

const PhoneMask = React.forwardRef<HTMLInputElement, MaskedInputProps>(
  function PhoneMaskComponent(props, ref) {
    const { onChange, name, ...rest } = props;

    return (
      //@ts-ignore
      <IMaskInput
        {...rest}
        mask="(00) 00000-0000"
        definitions={{ "#": /[0-9]/ }}
        unmask={false}
        inputRef={ref}
        name={name}
        onAccept={(val: any) => {
          onChange({
            target: { name, value: val },
          } as React.ChangeEvent<HTMLInputElement>);
        }}
      />
    );
  }
);

const CountryCodeMask = React.forwardRef<HTMLInputElement, MaskedInputProps>(
  function CountryCodeMaskComponent(props, ref) {
    const { onChange, name, ...rest } = props;

    return (
      //@ts-ignore
      <IMaskInput
        {...rest}
        mask="+000"
        definitions={{ "#": /[0-9]/ }}
        unmask={false}
        inputRef={ref}
        name={name}
        onAccept={(val: any) => {
          onChange({
            target: { name, value: val },
          } as React.ChangeEvent<HTMLInputElement>);
        }}
      />
    );
  }
);

export const MaskedPhoneInput = ({
  value,
  onChange,
  countryCode,
  onCountryCodeChange,
}: {
  value: string;
  onChange: (e: any) => void;
  countryCode: string;
  onCountryCodeChange: (e: any) => void;
}) => {
  return (
    <div style={{ display: "flex", gap: "12px", alignItems: "flex-end", width: "100%" }}>
      <CustomTextField
        label="Cód. País"
        name="countryCode"
        value={countryCode}
        onChange={onCountryCodeChange}
        InputProps={{
          inputComponent: CountryCodeMask as any,
        }}
        variant="standard"
        style={{ width: "90px", flexShrink: 0 }}
      />
      <CustomTextField
        label="Telefone"
        name="telefone"
        value={value}
        onChange={onChange}
        InputProps={{
          inputComponent: PhoneMask as any,
        }}
        variant="standard"
        fullWidth
      />
    </div>
  );
};
